import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { API_BASE } from '@/utils/api';
import { DesignPicker } from '@/components/settings/DesignPicker';

// Tema que reciben los negocios nuevos (panel y menú del cliente)
export const AppearanceDefaultsTab = () => {
  const [value, setValue] = useState(null);
  useEffect(() => { axios.get(`${API_BASE}/admin/appearance/defaults`).then(r => setValue(r.data.new_business_theme)).catch(() => {}); }, []);
  const save = async (v) => {
    const prev = value;
    setValue(v);
    try {
      await axios.put(`${API_BASE}/admin/appearance/defaults`, { new_business_theme: v });
      toast.success('Tema para negocios nuevos guardado');
    } catch {
      setValue(prev);
      toast.error('No se pudo guardar');
    }
  };
  return (
    <Card>
      <CardHeader>
        <CardTitle>Tema para negocios nuevos</CardTitle>
        <CardDescription>Los negocios que se den de alta desde ahora arrancan con este tema. Los existentes no cambian.</CardDescription>
      </CardHeader>
      <CardContent className="max-w-xl">
        {value && <DesignPicker value={value} onChange={save} testid="platform-new-business-design" />}
      </CardContent>
    </Card>
  );
};
